angular.module('gc.share-popin', ['gc.user'])
.directive('sharePopin', [
  '$rootScope', '$timeout', '$document', 'Utils', 'ShareService', 'CommentService',
  function ($rootScope, $timeout, $document, Utils, ShareService, CommentService) {

  'use strict';
  return {
    scope: {
      comment: '=',
      placement: '=',
      show: '=',
    },
    restrict: 'E',
    templateUrl: 'sharePopin.html',
    link: function ($scope, el, attrs, controller) {
      if (!$scope.show) return;

      function update() {
        var targetRect = $scope.placement.getBoundingClientRect();
        var scrollPos = Utils.getScrollPosition();
        var bodyBox = document.querySelector('.gc-body').getBoundingClientRect();

        $scope.popinCoord = {
          x: targetRect.left + scrollPos.left - bodyBox.left,
          y: targetRect.top - 10 + scrollPos.top,
        };

        // center popin
        var popinRect = { width: 170, height: 75 };
        $scope.popinCoord.x += popinRect.width / 2 * ($rootScope.rtl ? -.5 : -1);
        $scope.popinCoord.y -= popinRect.height / 2;

        if ($scope.popinCoord.x < 10) $scope.popinCoord.x = 10;


        if ($scope.comment.author) {
          CommentService.getUserObject($scope.comment.author._id).success(function(profile) {
            $rootScope.popinShare.profile = profile.user;
          });
        }

        $scope.short_url = '';

        // Replacing the comment_id by an empty string to avoid bug with yak.ly generated URL
        ShareService.shortenUrl($scope.comment.thread.url || document.URL, $scope.comment._id).success(function (data) {
          $scope.short_url = data.short_url;
        });
      }

      $scope.$watch('placement', update);

      $scope.sharer = function (network) {
        mixpanel.track('comment:share:social', network);
        ShareService.openShareWindow(network, $scope.short_url);
      };

      $scope.copyClipboard = function(event) {
        mixpanel.track('comment:share:yakli');

        var $input = event.target;
        $input.setSelectionRange(0, 9999);
        document.execCommand('copy');

        $scope.copied = true;
        $timeout(function () {
          $scope.copied = false;
        }, 1500);
      };

      $timeout(function () {
        var input = el[0].querySelector('.share-shortened-url');

        $document.on('click', function (event) {
          if (
            !input.contains(event.target) &&
            !$(event.target).hasClass('.gc-share') &&
            !$(event.target).parents('.gc-share').length
          ) {
            $document.off('click');
            $timeout(function () {
              $scope.show = false;
            });
          }
        });
      });
    }
  };
}]);
